import { useIonRouter, useIonViewWillEnter, IonBackButton, IonButton, IonButtons, IonCard, IonCheckbox, IonGrid, IonCol, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonTitle, IonToolbar } from "@ionic/react";
import { checkmarkOutline, cameraReverseOutline, sendOutline } from "ionicons/icons";
import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Point, Area } from "react-easy-crop/types";
import { Camera, CameraResultType } from '@capacitor/camera';
import { RouteComponentProps } from "react-router-dom";
import { showTab, hideTab } from "../components/Tabs";

import NServer from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';

interface ImageCropDetail extends RouteComponentProps<{
    type: string,
    name: string,
    callback : string
    ax : string,
    ay : string
    }> 
{} 

const ImgCrop: React.FC<ImageCropDetail> = ({ match }) => {
    
    const [imageFilePath, setImage] = useState("");
    const [validImage, setValidImage] = useState(false);
    
    const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [cropArea, setCropArea] = useState<Area>({ x : 0, y : 0, width: 0, height: 0});

    //	Initializing our router
	const router = useIonRouter();

    const onCropComplete = useCallback(
        (croppedArea: Area, croppedAreaPixels: Area) => {
            // console.log(croppedArea, croppedAreaPixels);
            setCropArea(croppedAreaPixels);
        },
        []
    );

    const takePicture = async () => {
        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Uri
        });

        // image.webPath will contain a path that can be set as an image src.
        // You can access the original file using image.path, which can be
        // passed to the Filesystem API to read the raw data of the image,
        // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
        var imageUrl = image.webPath;
        if (imageUrl !== undefined)
        {
            setImage(imageUrl);
            setValidImage(true);
        }
    };

    // success
    const confirmSuccess = () => {
        router.push("/" + match.params.callback + "/" + match.params.name, "back", "pop");
        window.location.reload();
    };

    // upload the image
    const UploadImage = async() => {

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            name: match.params.name, 
            type: match.params.type,
            cx: cropArea.x, 
            cy: cropArea.y, 
            cw: cropArea.width, 
            ch: cropArea.height
        }

        var server = new NServer();
        await server.uploadImage(imageFilePath, state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            confirmSuccess();
        }
    };

    useIonViewWillEnter(() => {
        takePicture();
    });

    return (
        <IonPage>
            <IonContent fullscreen>
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/home" ></IonBackButton>
                    </IonButtons>
                    <IonButtons className="ion-padding-end" slot="end">
                        <IonButton className="main-but" fill="clear" color="secondary" onClick={takePicture} >
                            <IonIcon icon={cameraReverseOutline}/> &nbsp;
                            Pick Photo
                        </IonButton>
                        <IonButton className="main-but" fill="clear" color="primary" onClick={UploadImage} disabled={!validImage} >
                            <IonIcon icon={checkmarkOutline}/> &nbsp;
                            Submit
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                
                <Cropper
                    image={imageFilePath}
                    crop={crop}
                    zoom={zoom}
                    aspect={ parseInt(match.params.ax) / parseInt(match.params.ay) }
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                />
            </IonContent>
        </IonPage>
    );
};
export default ImgCrop;